/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import Grid from "@mui/material/Grid";
import { PositionButtons } from "cms/fields/field-lists/position-buttons";
import { RemoveIcon } from "cms/fields/field-lists/remove-icon";

const ItemRightHandler = (props) => {
    
    const currentIndex = props?.currentIndex;
    const value = props?.value;

    return (
        <>
            <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                <div className='right-handler'>
                    <PositionButtons currentIndex={currentIndex} />
                    <RemoveIcon
                        className="simplicity-composer-field-editor-remove"
                        value={value}
                    />
                </div>
            </Grid>
        </>
    );
};

ItemRightHandler.displayName = "ItemRightHandler";
export { ItemRightHandler };
